import { useFlagValue } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { AuthorizePaymentCheck } from './AuthorizePaymentCheck';
import { AuthorizePaymentJPMC } from './AuthorizePaymentJPMC';
import { InterCompany } from './interCompany/InterCompany';
import { getPayByVirtualCard } from './selector';

export const AuthorizePaymentPage = (): React.JSX.Element => {
  const interCompanyFlag = useFlagValue('dmsAccountingIntercompanyPayment');
  const isPayByVirtualCard = useAppSelector(getPayByVirtualCard);

  const interCompany = () =>
    interCompanyFlag ? <InterCompany /> : <AuthorizePaymentJPMC />;

  return isPayByVirtualCard ? interCompany() : <AuthorizePaymentCheck />;
};
